export default __webpack_public_path__ + "static/media/twitter.ac414edb.svg";